import { companyName } from 'config'
import { removeNonPagePermissions } from 'hooks/hasPagePermissions'
import { usePermissions } from 'hooks/usePermissions'
import Invoice from 'pages/Loan/Servicing/Invoice/Invoice'
import { useEffect, useMemo, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useTitle } from 'utils/pageTitle'

import { AccountingCategories } from './AccountingCategories'
import { AccountningVendorCategories } from './AccountingVendorCategories'
import { AccountingVendors } from './AccountingVendors'
import { Accounts } from './Accounts'
import { AccountsReceivable } from './AccountsReceivable'
import { AccountingDashboard } from './Dashboard'
import { EscrowCustodial } from './EscrowCustodial'
import { FinancialStatements } from './FinancialStatements'
import { GeneralLedger } from './GeneralLedger'
import { HedgingFairValue } from './HedgingFairValue'
import { LoanSalesTrades } from './LoanSalesTrades'
import { LoanSubledger } from './LoanSubledger'
import { ReconciliationEngine } from './ReconciliationEngine'
import { ServicingMsr } from './ServicingMsr'
import { TreasuryWires } from './TreasuryWires'
import { TrialBalance } from './TrialBalance'
import { TrustAccounts } from './TrustAccounts'
import { WarehouseLines } from './WarehouseLines'

type menuType = {
  [key: string]: string // fix this
}

export default function ManageAccountings() {
  useTitle(`Accountings - ${companyName}`)

  const { menu = '' } = useParams() as { menu?: string }
  const navigate = useHistory()
  const [selectedMenu, setSelectedMenu] = useState(menu)
  const [menus, setMenus] = useState<menuType>({})

  const { hasPermission } = usePermissions()

  useEffect(() => {
    let temp: menuType = {}
    if (hasPermission('Accounting')) {
      temp = {
        accountingDashboard: 'Accounting Dashboard',
        accounts: 'Chart Of Accounts',
        generalLedger: 'General Ledger',
        trialBalance: 'Trial Balance',
        financialStatements: 'Financial Statements',
        loanSubledger: 'Loan Subledger',
        warehouseLines: 'Warehouse Lines',
        treasuryWires: 'Treasury & Wires',
        loanSalesTrades: 'Loan Sales & Trades',
        hedgingFairValue: 'Hedging & Fair Value',
        escrowCustodial: 'Escrow & Custodial',
        trustAccounts: 'Trust Accounts',
        servicingMsr: 'Servicing & MSR',
        reconciliationEngine: 'Reconciliation',
        accountingCategories: 'Accounting Categories',
        invoices: 'Invoices',
        accountsReceivable: 'Accounts Receivables',
        vendors: 'Vendors',
        vendorCategories: 'Vendor Categories',
      }
      removeNonPagePermissions(temp, ['manage_accountings'])
    }
    setMenus(temp)
  }, [])

  const setMenu = (menuItem: string) => {
    setSelectedMenu(menuItem)
    navigate.push(`/accountings/${menuItem}`)
  }

  const renderFragment = useMemo(() => {
    switch (selectedMenu) {
      case 'accountingDashboard':
        return <AccountingDashboard />

      case 'accounts':
        return <Accounts />

      case 'generalLedger':
        return <GeneralLedger />

      case 'trialBalance':
        return <TrialBalance />

      case 'financialStatements':
        return <FinancialStatements />

      case 'loanSubledger':
        return <LoanSubledger />

      case 'warehouseLines':
        return <WarehouseLines />

      case 'treasuryWires':
        return <TreasuryWires />

      case 'loanSalesTrades':
        return <LoanSalesTrades />

      case 'hedgingFairValue':
        return <HedgingFairValue />

      case 'escrowCustodial':
        return <EscrowCustodial />

      case 'trustAccounts':
        return <TrustAccounts />

      case 'servicingMsr':
        return <ServicingMsr />

      case 'reconciliationEngine':
        return <ReconciliationEngine />

      case 'accountingCategories':
        return <AccountingCategories />

      case 'invoices':
        return <Invoice isLoan={false} />

      case 'accountsReceivable':
        return <AccountsReceivable />

      case 'vendors':
        return <AccountingVendors />

      case 'vendorCategories':
        return <AccountningVendorCategories />
      default: {
        return <div>Comming Soon...</div>
      }
    }
  }, [selectedMenu])

  useEffect(() => {
    let newMenu = menu
    if (!menu || !Object.keys(menus).includes(newMenu)) newMenu = Object.keys(menus)[0]
    if (!newMenu) return
    setMenu(newMenu)
  }, [menus, menu])

  return (
    <div className="admin-tools-container py-6">
      <div className="admin-tools-wrapper max-w-screen-2xl m-auto grid grid-cols-12 gap-6 px-2">
        <div className="sidebar-left col-span-12 md:col-span-3 shrink-0 bg-white shadow1 rounded">
          <ul className="sidebar-items flex flex-col p-4 pb-20">
            {Object.keys(menus).map((item: string, index) => {
              return (
                <li
                  key={index}
                  onClick={() => {
                    setMenu(item)
                  }}
                  className="border-b py-2"
                >
                  <p
                    className={`hover:underline cursor-pointer ${
                      selectedMenu === item ? 'border px-4 py-1 bg-zinc-100' : 'py-1'
                    }`}
                  >
                    {index + 1}. {menus[item as keyof typeof menus]}
                  </p>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="content-right col-span-12 md:col-span-9 bg-white p-4 rounded shadow1">{renderFragment}</div>
      </div>
    </div>
  )
}
